const en = {
  items: "",
  total: 'Total',
    createNewTask: "Place Order",
    taskList: "Order List",
    hasComplete: "Completed",
    createTime: "Order Time",
    belongUser: "Service Applicant",
    taskIndex: "Order Number",
    animalType: "Animal Species",
    geneName: "Gene Name",
    editType: "Gene Editing Type",
    status: "Status",
    search : "Search",
    reset : "Reset",
    orderBy : "List by",
    description : "Description",
    operation: "Operation",
    detail : "Detail",
    other : "Others",
    edit: "Edit",
    delete: "Delete",
    quit: "Be Canceled",
    smallMouse : "Mouse",
    bigMouse : "Rat",
    knockOut : "Knock-out",
    knockIn : "Knock-in",
    pointMutation : "Point Mutation",
    conditionalKnockout : "Conditional Knock-out",
    spotInsert : "Site-specific Insertion",
    randomInsert : "Random Insertion",
    geneReplace: "Gene Replacement",
    uploadFile : "Upload file(s)",
    uploadTip: "Upload File(s) by Clicking or Dragging and Dropping File(s) Here",
    proxyOrder : "Place Order For",
    cancel: "Cancel",
    commit: "Submit",
    makeApply : "Place Order",
    produceProgrammes : "Strategy Design",
    molecularCloning : "Molecular Cloning",
    cloneDetail:"sgRNA合成、分子克隆、质粒大提",
    microinjection : "Embryos Microinjection",
    f0mice : "F0 Screening",
    f1mice : "F1 Genotyping",
    ArrangeTransfer : "Deliver to Lab",
    ConfirmCompletion : "Confirmation",
    nextStep : "Next Step",
    completeTime : "Finish Time",
    restart : "Restart from this step",
    annex: "Attachment",
    remark: "Note",
    save: "Save",
    history : "Past Orders",
    Programmes : "Design",
    taskStream : "Workflow",
    iKnow: "Got it",
    home: "Ongoing Projects",
    sendEmail: "Send notification email",
    orderCompleted: "Order completed!",
}
export default en;